import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { NotificationProvider } from "./context/NotificationContext";
import { CompanyProvider } from "./context/CompanyContext";
import { LicenseProvider } from "./context/LicenseContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/layout/Layout";

// Pages
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import FilePage from "./pages/FilePage";
import EditPage from "./pages/EditPage";
import ViewPage from "./pages/ViewPage";
import TransactionsPage from "./pages/TransactionsPage";
import SetupPage from "./pages/SetupPage";
import ToolsPage from "./pages/ToolsPage";
import HelpPage from "./pages/HelpPage";
import AccountingControls from "./pages/AccountingControls";

// New Payroll Module Pages
import TaxSetupPage from "./pages/TaxSetupPage";
import PayrollPage from "./pages/PayrollPage";
import PayrollReportsPage from "./pages/PayrollReportsPage";
import CostAccountingPage from "./pages/CostAccountingPage";
import LicensingPage from "./pages/LicensingPage";
import FinancialReportsPage from "./pages/FinancialReportsPage";
import PricingPage from "./pages/PricingPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import SubscriptionPage from "./pages/SubscriptionPage";
import CustomReportBuilderPage from "./pages/CustomReportBuilderPage";

// Legacy pages (to be phased out)
import Customers from "./pages/Customers";
import Reports from "./pages/Reports";
import Expenses from "./pages/Expenses";

// Wrapper to handle auth callback detection
function AppRouter() {
  const location = useLocation();

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<Login />} />

      {/* Protected Routes */}
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                {/* Dashboard (Home) */}
                <Route path="/" element={<Dashboard />} />
                
                {/* File Menu */}
                <Route path="/file/*" element={<FilePage />} />
                
                {/* Edit Menu */}
                <Route path="/edit/*" element={<EditPage />} />
                
                {/* View Menu */}
                <Route path="/view/*" element={<ViewPage />} />
                
                {/* Transactions Menu */}
                <Route path="/transactions/*" element={<TransactionsPage />} />
                
                {/* Setup Menu */}
                <Route path="/setup/*" element={<SetupPage />} />
                
                {/* NEW: Tax & Payroll Module */}
                <Route path="/tax-setup" element={<TaxSetupPage />} />
                <Route path="/payroll" element={<PayrollPage />} />
                <Route path="/payroll-reports" element={<PayrollReportsPage />} />
                <Route path="/financial-reports" element={<FinancialReportsPage />} />
                <Route path="/cost-accounting" element={<CostAccountingPage />} />
                
                {/* Tools Menu */}
                <Route path="/tools/*" element={<ToolsPage />} />
                
                {/* Accounting Controls */}
                <Route path="/accounting-controls" element={<AccountingControls />} />
                
                {/* Help Menu */}
                <Route path="/help/*" element={<HelpPage />} />
                
                {/* Legacy Routes - keeping for backward compatibility */}
                <Route path="/customers" element={<Customers />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/reports/*" element={<Reports />} />
                <Route path="/expenses" element={<Expenses />} />
                
                {/* Quick Entry - redirect to transactions */}
                <Route path="/quick-entry/*" element={<TransactionsPage />} />
                
                {/* Accounting - redirect to view/transactions */}
                <Route path="/accounting/*" element={<ViewPage />} />
                
                {/* Banking - redirect to transactions */}
                <Route path="/banking/*" element={<TransactionsPage />} />
                
                {/* Payroll - redirect to transactions */}
                <Route path="/payroll/*" element={<TransactionsPage />} />
                
                {/* Approvals - redirect to transactions posting queue */}
                <Route path="/approvals/*" element={<TransactionsPage />} />
                
                {/* Admin */}
                <Route path="/admin/licensing" element={<LicensingPage />} />
                <Route path="/admin/pricing" element={<PricingPage />} />
                <Route path="/admin/pricing/success" element={<PaymentSuccessPage />} />
                <Route path="/admin/*" element={<SetupPage />} />
                
                {/* Account */}
                <Route path="/account/subscription" element={<SubscriptionPage />} />
                
                {/* Custom Reports */}
                <Route path="/custom-reports" element={<CustomReportBuilderPage />} />
                
                {/* AI Assistant - redirect to dashboard */}
                <Route path="/assistant" element={<Dashboard />} />
                
                {/* Catch all - redirect to dashboard */}
                <Route path="*" element={<Dashboard />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CompanyProvider>
          <LicenseProvider>
            <NotificationProvider>
              <BrowserRouter>
                <AppRouter />
              </BrowserRouter>
            </NotificationProvider>
          </LicenseProvider>
        </CompanyProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
